// import ReactMarkdown from "react-markdown";
import Editor from "./Components/Editor/Editor";

function App() {
  return (
    <div className="App">
      <Editor />
      {/* <ReactMarkdown children="**Hello**" /> */}
    </div>
  );
}

export default App;
